import { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../App.css';
import { translations } from '../translations';
import { SEOHead } from '../components/SEOHead';
import { DiningCards } from '../components/DiningCards';
import { publishedTourCards, usableTourCards } from '../lib/tourCards';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const tourImages = {
  '1': 'https://customer-assets.emergentagent.com/job_e1f4408b-0273-4e3a-a89a-6d5a2e02000a/artifacts/4bfh4yp8_EUISUAHIDIST-2.jpg',
  '2': 'https://customer-assets.emergentagent.com/job_e1f4408b-0273-4e3a-a89a-6d5a2e02000a/artifacts/qmka267p_07502e5a482d2d5ae7338292c00ebbf7.jpg',
  '3': 'https://customer-assets.emergentagent.com/job_e1f4408b-0273-4e3a-a89a-6d5a2e02000a/artifacts/mr4js6lk_sypnoqmxrlg1lqsyt7tq.jpg',
  '4': 'https://customer-assets.emergentagent.com/job_e1f4408b-0273-4e3a-a89a-6d5a2e02000a/artifacts/exug6me0_94.jpg',
  '5': 'https://customer-assets.emergentagent.com/job_e1f4408b-0273-4e3a-a89a-6d5a2e02000a/artifacts/hv8iif2x_Mercedes-vito-01-1.jpg',
};

const sectionBgImages = [
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/wz19565z_9c.jpg',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/wwitgywe_40.jpg',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/ukm0anx7_74.jpg',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/8elisbo1_caption%289%29.jpg',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/iz9x4wud_topkap%C4%B1%20saray%C4%B1.png',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/4zj8l987_74%282%29.jpg',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/khlh49mo_caption%289%29.jpg',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/lcnec06w_9c.jpg',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/rd8ua5y9_medusa%20head%20%281%29%20%281%29.png',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/70qq7ktm_topkap%C4%B1%20saray%C4%B1.png',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/20dshn17_topkap%C4%B1%20dagger.png',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/qpjl3les_Seraphim%20angel.png',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/lzn3ui6p_deeis%20mosaic.png',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/aoq219r5_vector-illustration-colored-istanbul-map-with-famous-landmarks-HYR7K7.jpg',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/3dn19j1u_turkey-1354355_1280-1024x682.jpg',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/evxrw1c3_8584661339_9b29126bf2_b.jpg',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/5wiqgap2_Itstanbul-Grand-Bazaar-Inside_752332696_L-1024x682.webp',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/p8or16ef_shutterstock_1110842891.jpg',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/z4ok8j71_0355i12000nd0kdgg6F53_C_960_660_Q50.jpg',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/u9j32ui6_99461d6d20c3cf98959dbb88168f8114.jpg',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/4pb0iz6a_208f9be599a9de3bc233e3b4ae6db60b.jpg',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/ttrpxc1e_yerebatan-sarnici-10.jpg',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/6skforyl_bd5ed2794752efc5339edfec8d8ce84f.jpg',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/iiu4pbqp_Topkapi_Palace_Imperial_Hall_Harem_.jpg_04.jpg',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/4ipt6dsj_5d694bceb13f866ab525ea585820404b.jpg',
  'https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/3wb06bpq_ISTANBULGULHANEPARKSABRISAVCI17_20171016160053149.jpg',
  'https://images.unsplash.com/photo-1710897248755-ea7a90a18e6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxJc3RhbmJ1bCUyMFR1cmtleSUyMHZpYnJhbnQlMjBjb2xvcmZ1bCUyMHRyYXZlbHxlbnwwfHx8fDE3NzIzMDU5OTd8MA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1650801019827-8a0a81cca7b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxJc3RhbmJ1bCUyMFR1cmtleSUyMHZpYnJhbnQlMjBjb2xvcmZ1bCUyMHRyYXZlbHxlbnwwfHx8fDE3NzIzMDU5OTd8MA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1695109237033-7bb924cefde6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxJc3RhbmJ1bCUyMFR1cmtleSUyMHZpYnJhbnQlMjBjb2xvcmZ1bCUyMHRyYXZlbHxlbnwwfHx8fDE3NzIzMDU5OTd8MA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1760121406592-35069cfc0a5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxJc3RhbmJ1bCUyMFR1cmtleSUyMHZpYnJhbnQlMjBjb2xvcmZ1bCUyMHRyYXZlbHxlbnwwfHx8fDE3NzIzMDU5OTd8MA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1707315446562-b516f2f9c716?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxJc3RhbmJ1bCUyMEJvc3Bob3J1cyUyMHN1bnNldCUyMG1vc3F1ZSUyMHBhbm9yYW1hfGVufDB8fHx8MTc3MjMwNjAxMXww&ixlib=rb-4.1.0&q=85'
];

export default function ToursPage({ language, setLanguage }) {
  const t = translations[language];
  const location = useLocation();
  const navigate = useNavigate();

  const langText = (en, ar, ru, tr) => {
    if (language === 'ar') return ar;
    if (language === 'ru') return ru;
    if (language === 'tr') return tr;
    return en;
  };
  const [tours, setTours] = useState(publishedTourCards);
  const [sectionBgIndex, setSectionBgIndex] = useState(0);
  const [showInquiryModal, setShowInquiryModal] = useState(false);
  const [selectedService, setSelectedService] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });
  const [openDropdown, setOpenDropdown] = useState(null);
  const headerRef = useRef(null);
  const [inquiryForm, setInquiryForm] = useState({ 
    name: '', email: '', phone: '', message: '',
    arrivalFlight: '', departureFlight: '', specialRequirements: '', plannedDate: ''
  });

  useEffect(() => {
    axios.get(`${API}/tours`, { timeout: 10000 })
      .then(res => setTours(usableTourCards(res.data)))
      .catch(() => setTours(publishedTourCards()));
    const bgInterval = setInterval(() => {
      setSectionBgIndex((prev) => (prev + 1) % sectionBgImages.length);
    }, 15000);
    return () => clearInterval(bgInterval);
  }, []); // API is module-level const, setSectionBgIndex is stable

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  }, [location.hash, tours]);

  const handleClickOutside = useCallback((e) => {
    if (headerRef.current && !headerRef.current.contains(e.target)) {
      setOpenDropdown(null);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('touchstart', handleClickOutside);
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  const handleDropdownTrigger = (e, dropdownId) => {
    if (openDropdown === dropdownId) {
      setOpenDropdown(null);
    } else {
      e.preventDefault();
      setOpenDropdown(dropdownId);
    }
  };

  const handleDropdownItemClick = () => {
    setOpenDropdown(null);
  };

  const openInquiryModal = (serviceType, serviceName) => {
    setSelectedService(serviceType);
    setInquiryForm({ ...inquiryForm, message: `I'm interested in ${serviceName}`, arrivalFlight: '', departureFlight: '', specialRequirements: '', plannedDate: '' });
    setShowInquiryModal(true);
  };

  const handleInquirySubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/inquiries`, { ...inquiryForm, service_type: selectedService });
      setMessage({ text: t.inquiry?.inquirySuccess || 'Inquiry submitted successfully!', type: 'success' });
      setInquiryForm({ name: '', email: '', phone: '', message: '' });
      setShowInquiryModal(false);
    } catch (error) {
      setMessage({ text: t.inquiry?.inquiryError || 'Error submitting inquiry.', type: 'error' });
    } finally {
      setLoading(false);
      setTimeout(() => setMessage({ text: '', type: '' }), 3000);
    }
  };

  return (
    <div className="app">
      <SEOHead
        title={language === 'ar' ? (t.seo?.travelTitle || 'Istanbul Tours & Private Guided Excursions | Viaturkey') : 'Istanbul Tours & Private Guided Excursions | Viaturkey'}
        description={language === 'ar' ? (t.seo?.travelDesc || '') : "Plan private guided tours in Istanbul with licensed Arabic-speaking guides. Shore excursions from Galataport, Bosphorus cruises, food tours, and airport transfers for GCC travelers. Tour bookings facilitated through licensed partner agencies."}
        canonical="https://viaturkey.net/travel"
      />
      {/* Tours Hero */}
      <section className="page-hero tours-page-hero">
        <div className="section-bg-carousel">
          {sectionBgImages.map((img, idx) => (
            <div key={`bg-${idx}-${img.slice(-20)}`} className={`section-bg-slide ${idx === sectionBgIndex ? 'active' : ''}`} style={{ backgroundImage: `url(${img})` }}></div>
          ))}
          <div className="page-hero-overlay"></div>
        </div>
        <div className="container page-hero-content">
          <h1>{t.tours.title}</h1>
          <p>{t.tours.subtitle}</p>
        </div>
      </section>

      {/* Why Book With Us */}
      <section className="tours-section" data-testid="tours-section">
        <div className="container">
          <div className="why-book-us">
            <h3>{t.tours.whyBookTitle}</h3>
            <div className="why-book-grid">
              <div className="why-book-card">
                <div className="why-book-icon">✨</div>
                <h4>{t.tours.tailorMade}</h4>
                <p>{t.tours.tailorMadeDesc}</p>
              </div>
              <div className="why-book-card">
                <div className="why-book-icon">&#128104;&#8205;&#127891;</div>
                <h4>{t.tours.expertGuides}</h4>
                <p>{t.tours.expertGuidesDesc}</p>
              </div>
              <div className="why-book-card">
                <div className="why-book-icon">&#128270;</div>
                <h4>{t.tours.transparency}</h4>
                <p>{t.tours.transparencyDesc}</p>
              </div>
            </div>
          </div>

          {/* Commission Warning Section */}
          <div className="commission-warning-section" data-testid="commission-warning-section">
            <h3 className="commission-warning-title">{t.tours.commissionWarning.title}</h3>
            <div className="commission-warning-logos">
              <img src="https://customer-assets.emergentagent.com/job_dbb6da4c-d4c7-44c6-9c82-2a61cf43263d/artifacts/1stysj51_Viator_Logo.jpg" alt="Viator" className="commission-logo" />
              <img src="https://customer-assets.emergentagent.com/job_dbb6da4c-d4c7-44c6-9c82-2a61cf43263d/artifacts/6m0f89ze_64785251b8e9c02256ce4474_getyourguide-funding.jpg" alt="GetYourGuide" className="commission-logo" />
              <img src="https://customer-assets.emergentagent.com/job_dbb6da4c-d4c7-44c6-9c82-2a61cf43263d/artifacts/cokl89m3_d2683934c598376fcd0dbaec32a08380.jpg" alt="TripAdvisor" className="commission-logo" />
            </div>
            <p className="commission-warning-text">{t.tours.commissionWarning.message}</p>
            <p className="commission-direct-text">{t.tours.commissionWarning.directMessage}</p>
          </div>

          {/* Pricing Banner */}
          <div className="tour-pricing-banner" data-testid="tour-pricing-banner">
            <p className="pricing-banner-main">{t.tours.pricingBanner}</p>
            <p className="pricing-banner-solo">{t.tours.pricingSolo}</p>
          </div>

          {/* Tour Photo Gallery */}
          <div className="tour-photo-gallery" data-testid="tour-photo-gallery">
            <img src="https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/4zj8l987_74%282%29.jpg" alt={language === 'ar' ? 'المسجد الأزرق' : 'Blue Mosque'} loading="lazy" />
            <img src="https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/khlh49mo_caption%289%29.jpg" alt={language === 'ar' ? 'آيا صوفيا' : 'Hagia Sophia'} loading="lazy" />
            <img src="https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/lcnec06w_9c.jpg" alt={language === 'ar' ? 'مسلّات ميدان السلطان أحمد' : 'Sultanahmet Obelisks'} loading="lazy" />
            <img src="https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/rd8ua5y9_medusa%20head%20%281%29%20%281%29.png" alt={language === 'ar' ? 'رأس ميدوسا في صهريج البازيليك' : 'Medusa Head Basilica Cistern'} loading="lazy" />
            <img src="https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/70qq7ktm_topkap%C4%B1%20saray%C4%B1.png" alt={language === 'ar' ? 'قصر توبكابي' : 'Topkapi Palace'} loading="lazy" />
            <img src="https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/20dshn17_topkap%C4%B1%20dagger.png" alt={language === 'ar' ? 'خنجر توبكابي' : 'Topkapi Dagger'} loading="lazy" />
            <img src="https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/qpjl3les_Seraphim%20angel.png" alt={language === 'ar' ? 'ملاك السيرافيم في آيا صوفيا' : 'Seraphim Angel Hagia Sophia'} loading="lazy" />
            <img src="https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/lzn3ui6p_deeis%20mosaic.png" alt={language === 'ar' ? 'فسيفساء الديسيس' : 'Deesis Mosaic'} loading="lazy" />
            <img src="https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/aoq219r5_vector-illustration-colored-istanbul-map-with-famous-landmarks-HYR7K7.jpg" alt={language === 'ar' ? 'خريطة إسطنبول وأشهر معالمها' : 'Istanbul Map with Famous Landmarks'} loading="lazy" />
            <img src="https://customer-assets.emergentagent.com/job_08630688-08aa-4216-a68f-909227f2d501/artifacts/3dn19j1u_turkey-1354355_1280-1024x682.jpg" alt={language === 'ar' ? 'خزف تركي تقليدي' : 'Traditional Turkish Ceramics'} loading="lazy" />
          </div>

          {/* Featured Video Section */}
          <div className="travel-video-section" data-testid="travel-video-section">
            <div className="travel-video-content">
              <h3 className="travel-video-title">{t.tours.videoSection?.title || 'Explore Istanbul With Us'}</h3>
              <p className="travel-video-desc">{t.tours.videoSection?.desc || 'Join our guided tour through Istanbul\'s most iconic landmarks — the magnificent Blue Mosque and the historic Hagia Sophia. Experience the rich history, stunning architecture, and cultural heritage that makes Istanbul one of the world\'s most captivating cities.'}</p>
              <a href="https://wa.me/905075337545" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-whatsapp-tour" data-testid="video-inquiry-btn">
                <svg viewBox="0 0 32 32" fill="white" style={{width: '18px', height: '18px', flexShrink: 0}}><path d="M16 0C7.164 0 0 7.164 0 16c0 2.828 0.738 5.484 2.024 7.792L0.156 31.844l8.384-2.196C10.78 30.856 13.324 31.6 16 31.6c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.2c-2.444 0-4.748-0.668-6.712-1.832l-0.48-0.284-4.972 1.304 1.328-4.856-0.312-0.496C3.34 20.996 2.6 18.564 2.6 16 2.6 8.608 8.608 2.6 16 2.6S29.4 8.608 29.4 16 23.392 29.2 16 29.2zm7.788-10.636c-0.428-0.212-2.524-1.248-2.916-1.388-0.392-0.144-0.676-0.212-0.96 0.212-0.284 0.428-1.1 1.388-1.348 1.672-0.248 0.284-0.496 0.32-0.924 0.108-0.428-0.212-1.804-0.664-3.436-2.12-1.268-1.132-2.124-2.528-2.372-2.956-0.248-0.428-0.028-0.66 0.184-0.872 0.192-0.188 0.428-0.496 0.64-0.744 0.212-0.248 0.284-0.428 0.428-0.712 0.144-0.284 0.072-0.532-0.036-0.744-0.108-0.212-0.96-2.312-1.316-3.164-0.348-0.828-0.7-0.716-0.96-0.728-0.248-0.012-0.532-0.016-0.816-0.016s-0.744 0.108-1.132 0.532c-0.392 0.428-1.496 1.46-1.496 3.56s1.532 4.132 1.744 4.416c0.212 0.284 3 4.58 7.26 6.42 1.016 0.44 1.808 0.704 2.428 0.9 1.02 0.324 1.948 0.28 2.684 0.168 0.82-0.12 2.524-1.032 2.88-2.028 0.356-0.996 0.356-1.852 0.248-2.028-0.104-0.18-0.388-0.288-0.816-0.5z"/></svg>
                {langText('Contact Us', 'تواصل معنا', 'Свяжитесь с нами', 'Bize Ulaşın')}
              </a>
            </div>
            <div className="travel-video-player">
              <video controls playsInline preload="metadata" webkit-playsinline="true" data-testid="travel-video">
                <source src="https://customer-assets.emergentagent.com/job_dbb6da4c-d4c7-44c6-9c82-2a61cf43263d/artifacts/qgsedhn4_0301%281%29.mp4" type="video/mp4" />
              </video>
            </div>
          </div>

          {/* Tour Cards */}
          <div className="tours-grid">
            {tours.map((tour) => (
              <div key={tour.id} className="tour-card" id={`tour-${tour.id}`} data-testid={`tour-card-${tour.id}`}>
                {tourImages[tour.id] && (
                  <div className="tour-card-image-wrapper">
                    <img src={tourImages[tour.id]} alt={t.tours.tourDetails[tour.id]?.name || tour.name} className="tour-card-image" loading="lazy" data-testid={`tour-image-${tour.id}`} />
                  </div>
                )}
                <h3>{t.tours.tourDetails[tour.id]?.name || tour.name}</h3>
                <p className="tour-description">{t.tours.tourDetails[tour.id]?.description || tour.description}</p>
                {t.tours.tourDetails[tour.id]?.details && (
                  <div className="tour-additional-details">
                    <p style={{whiteSpace: 'pre-line', fontSize: '0.95rem', lineHeight: '1.6', color: '#475569'}}>
                      {t.tours.tourDetails[tour.id].details}
                    </p>
                  </div>
                )}
                <div className="tour-details">
                  <p><strong>{t.tours.duration}:</strong> {t.tours.tourDetails[tour.id]?.duration || tour.duration}</p>
                  <div className="highlights">
                    <strong>{t.tours.highlights}:</strong>
                    <ul>
                      {(t.tours.tourDetails[tour.id]?.highlights || tour.highlights).map((highlight, idx) => (
                        <li key={`h-${tour.id}-${idx}`}>{highlight}</li>
                      ))}
                    </ul>
                  </div>
                  {tour.included && (
                    <div className="included-section">
                      <strong>&#10003; {t.tours.included}:</strong>
                      <ul>
                        {(t.tours.tourDetails[tour.id]?.includedItems || t.tours.includedItems).map((item, idx) => (
                          <li key={`inc-${tour.id}-${idx}`}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {tour.excluded && (
                    <div className="excluded-section">
                      <strong>&#10007; {t.tours.excluded}:</strong>
                      <ul>
                        {(t.tours.tourDetails[tour.id]?.excludedItems || t.tours.excludedItems).map((item, idx) => (
                          <li key={`exc-${tour.id}-${idx}`}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div className="tour-footer">
                  <p className="pricing">
                    {({
                      '1': t.tours.priceFrom175,
                      '2': t.tours.priceFrom160,
                      '3': t.tours.priceFrom185,
                      '4': t.tours.priceFrom150,
                      '5': t.tours.contactPrice,
                    }[tour.id]) || t.tours.priceFrom200}
                  </p>
                  <a href={`https://wa.me/905075337545?text=${encodeURIComponent(t.tours.tourDetails[tour.id]?.whatsappMsg || ('Hi, I am interested in: ' + (t.tours.tourDetails[tour.id]?.name || tour.name)))}`} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-whatsapp-tour" data-testid={`whatsapp-btn-${tour.id}`}>
                    <svg viewBox="0 0 32 32" fill="white" style={{width: '18px', height: '18px', flexShrink: 0}}><path d="M16 0C7.164 0 0 7.164 0 16c0 2.828 0.738 5.484 2.024 7.792L0.156 31.844l8.384-2.196C10.78 30.856 13.324 31.6 16 31.6c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.2c-2.444 0-4.748-0.668-6.712-1.832l-0.48-0.284-4.972 1.304 1.328-4.856-0.312-0.496C3.34 20.996 2.6 18.564 2.6 16 2.6 8.608 8.608 2.6 16 2.6S29.4 8.608 29.4 16 23.392 29.2 16 29.2zm7.788-10.636c-0.428-0.212-2.524-1.248-2.916-1.388-0.392-0.144-0.676-0.212-0.96 0.212-0.284 0.428-1.1 1.388-1.348 1.672-0.248 0.284-0.496 0.32-0.924 0.108-0.428-0.212-1.804-0.664-3.436-2.12-1.268-1.132-2.124-2.528-2.372-2.956-0.248-0.428-0.028-0.66 0.184-0.872 0.192-0.188 0.428-0.496 0.64-0.744 0.212-0.248 0.284-0.428 0.428-0.712 0.144-0.284 0.072-0.532-0.036-0.744-0.108-0.212-0.96-2.312-1.316-3.164-0.348-0.828-0.7-0.716-0.96-0.728-0.248-0.012-0.532-0.016-0.816-0.016s-0.744 0.108-1.132 0.532c-0.392 0.428-1.496 1.46-1.496 3.56s1.532 4.132 1.744 4.416c0.212 0.284 3 4.58 7.26 6.42 1.016 0.44 1.808 0.704 2.428 0.9 1.02 0.324 1.948 0.28 2.684 0.168 0.82-0.12 2.524-1.032 2.88-2.028 0.356-0.996 0.356-1.852 0.248-2.028-0.104-0.18-0.388-0.288-0.816-0.5z"/></svg>
                    {langText('Contact Us', 'تواصل معنا', 'Свяжитесь с нами', 'Bize Ulaşın')}
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Also Available - Flexible Tours */}
          <div className="flexible-tours-section" data-testid="flexible-tours-section">
            <h3 className="flexible-tours-title">{t.tours.alsoAvailable}</h3>
            <div className="flexible-tours-grid">
              <div className="flexible-tour-card">
                <div className="flexible-tour-icon">&#9769;</div>
                <h4>{t.tours.christianHeritage}</h4>
              </div>
              <div className="flexible-tour-card">
                <div className="flexible-tour-icon">&#127963;</div>
                <h4>{t.tours.archaeologyTours}</h4>
              </div>
              <div className="flexible-tour-card">
                <div className="flexible-tour-icon">&#128717;</div>
                <h4>{t.tours.shoppingTours}</h4>
              </div>
            </div>
            <p className="flexible-tours-desc">{t.tours.flexibleToursIntro}</p>
            <p className="flexible-tours-contact">{t.tours.flexibleToursContact}</p>
            <button className="btn btn-primary" onClick={() => openInquiryModal('tourism', 'Flexible Tour Inquiry')} data-testid="flexible-tour-inquiry-btn">
              {t.tours.inquireNow}
            </button>
          </div>

          {/* Real Estate Consulting Service */}
          <div className="re-consulting-section" id="re-consulting" data-testid="re-consulting-section">
            <h3 className="re-consulting-title">{t.tours.realEstateConsulting.title}</h3>
            <div className="re-consulting-content">
              <div className="re-consulting-details">
                <p className="re-consulting-item"><span className="re-consulting-icon">&#128663;</span> {t.tours.realEstateConsulting.vanInfo}</p>
                <p className="re-consulting-item"><span className="re-consulting-icon">&#128188;</span> {t.tours.realEstateConsulting.consultingInfo}</p>
                <p className="re-consulting-desc">{t.tours.realEstateConsulting.description}</p>
              </div>
              <div className="re-consulting-cta" data-testid="re-consulting-cta">
                <p className="re-consulting-cta-text">{t.tours.realEstateConsulting.ctaText}</p>
                <button className="btn btn-primary" onClick={() => openInquiryModal('real_estate_consulting', 'Real Estate Consulting')} data-testid="re-consulting-inquiry-btn">
                  {t.tours.inquireNow}
                </button>
              </div>
            </div>
          </div>

          <DiningCards t={t} language={language} testIdPrefix="dining-card" sectionTestId="business-dining-section" sectionId="business-dining" />
        </div>
      </section>

      {/* Medical Tourism Section */}
      <section className="medical-tourism-section" id="medical-tourism" data-testid="medical-tourism-section">
        <div className="container">
          <h2 className="section-title">{t.medicalTourism.title}</h2>
          <p className="section-subtitle">{t.medicalTourism.subtitle}</p>
          <p className="medical-intro">{t.medicalTourism.intro}</p>

          <div className="medical-cta-bar">
            <a href="https://healthturkiye.gov.tr/faq" target="_blank" rel="noopener noreferrer" className="btn btn-primary" data-testid="health-turkiye-faq-link">
              {t.medicalTourism.healthTurkiye}
            </a>
            <a href="https://calendly.com/guzaliakin234" target="_blank" rel="noopener noreferrer" className="btn btn-primary" data-testid="medical-appointment-btn">
              {t.inquiry.bookCall || 'Book an Appointment'}
            </a>
          </div>

          <p className="medical-citation">{t.medicalTourism.citation}</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>{t.footer.rights}</p>
          <p>{t.footer.tagline}</p>
        </div>
      </footer>

      {/* WhatsApp */}
      <a href="https://wa.me/905075337545" target="_blank" rel="noopener noreferrer" className="whatsapp-float" data-testid="whatsapp-float-btn">
        <div className="whatsapp-content">
          <svg className="whatsapp-logo" viewBox="0 0 32 32" fill="white">
            <path d="M16 0C7.164 0 0 7.164 0 16c0 2.828 0.738 5.484 2.024 7.792L0.156 31.844l8.384-2.196C10.78 30.856 13.324 31.6 16 31.6c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.2c-2.444 0-4.748-0.668-6.712-1.832l-0.48-0.284-4.972 1.304 1.328-4.856-0.312-0.496C3.34 20.996 2.6 18.564 2.6 16 2.6 8.608 8.608 2.6 16 2.6S29.4 8.608 29.4 16 23.392 29.2 16 29.2zm7.788-10.636c-0.428-0.212-2.524-1.248-2.916-1.388-0.392-0.144-0.676-0.212-0.96 0.212-0.284 0.428-1.1 1.388-1.348 1.672-0.248 0.284-0.496 0.32-0.924 0.108-0.428-0.212-1.804-0.664-3.436-2.12-1.268-1.132-2.124-2.528-2.372-2.956-0.248-0.428-0.028-0.66 0.184-0.872 0.192-0.188 0.428-0.496 0.64-0.744 0.212-0.248 0.284-0.428 0.428-0.712 0.144-0.284 0.072-0.532-0.036-0.744-0.108-0.212-0.96-2.312-1.316-3.164-0.348-0.828-0.7-0.716-0.96-0.728-0.248-0.012-0.532-0.016-0.816-0.016s-0.744 0.108-1.132 0.532c-0.392 0.428-1.496 1.46-1.496 3.56s1.532 4.132 1.744 4.416c0.212 0.284 3 4.58 7.26 6.42 1.016 0.44 1.808 0.704 2.428 0.9 1.02 0.324 1.948 0.28 2.684 0.168 0.82-0.12 2.524-1.032 2.88-2.028 0.356-0.996 0.356-1.852 0.248-2.028-0.104-0.18-0.388-0.288-0.816-0.5z"/>
          </svg>
          <div className="whatsapp-text">
            <span className="whatsapp-label-en">{langText('Contact Us', 'تواصل معنا', 'Свяжитесь с нами', 'Bize Ulaşın')}</span>
          </div>
        </div>
      </a>

      {/* Inquiry Modal - Calendly Redirect */}
      {showInquiryModal && (
        <div className="modal-overlay" onClick={() => setShowInquiryModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} data-testid="inquiry-modal">
            <button className="modal-close" onClick={() => setShowInquiryModal(false)}>&times;</button>
            <h2>{t.inquiry.title}</h2>
            <p style={{ color: '#475569', marginBottom: '1.5rem', lineHeight: '1.6' }}>
              {t.realEstate.discoveryCall}
            </p>
            <a href="https://calendly.com/guzaliakin234" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ display: 'inline-block', textAlign: 'center', width: '100%' }} data-testid="calendly-link">
              {t.inquiry.bookCall || 'Book an Appointment'}
            </a>
          </div>
        </div>
      )}

      {message.text && (
        <div className={`toast toast-${message.type}`} data-testid="toast-message">{message.text}</div>
      )}
    </div>
  );
}
